import { IMenu } from 'src/app/models/menu.interface';


export interface IMenuState {
    menu: IMenu;
    dateMenu: string;
}

export const initialMenuState: IMenuState = {
    menu: null,
    dateMenu: ''
};
